import React, { Component } from 'react';
import { withStyles } from "@material-ui/core/styles";
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Tooltip from '@material-ui/core/Tooltip';

const styles = theme => ({
    iconView: {
        color: "white !important",
    }
});

class Dropdown extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleCloseOutside = this.handleCloseOutside.bind(this);
        this.state = {
            selected: this.props.selected,
            options: this.props.options,
            open: false,
            anchorEl: null,
            ITEM_HEIGHT: 48
        }
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleCloseOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleCloseOutside);
    }

    handleCloseOutside() {
        this.setState({ anchorEl: null, open: false });
    }

    handleClick(event) {
        this.setState({ anchorEl: event.currentTarget, open: true });
    };

    handleClose(event) {
        this.handleCloseOutside();
        if (event) {
            this.setState({ selected: event });
            this.props.setSelected(event);
        }
    };


    render() {
        let { classes } = this.props;
        return (
            <div className={this.props.className}>
                <Tooltip title="Filtrar lockers pelo status (em operação, em instalação ou em manutenção)">
                    <IconButton
                        aria-label="more"
                        aria-controls="long-menu"
                        aria-haspopup="true"
                        onClick={this.handleClick}
                    >
                        <MoreVertIcon className={classes.iconView} />
                    </IconButton>
                </Tooltip>
                <Menu
                    id="long-menu"
                    anchorEl={this.state.anchorEl}
                    keepMounted
                    open={this.state.open}
                    PaperProps={{
                        style: {
                            maxHeight: this.state.ITEM_HEIGHT * 5.5,
                            width: 100,
                        },
                    }}
                >
                    {this.state.options.map(option => (
                        <MenuItem key={option} selected={option === this.state.selected} onClick={() => this.handleClose(option)}>
                            {option}
                        </MenuItem>
                    ))}
                </Menu>
            </div>
        );
    }
}
export default withStyles(styles)(Dropdown);